import axios from 'axios'
import configManager from 'config/configManager'

const configData = configManager()
const apiBaseUrl = `${process.env.REACT_APP_API_BASE_URL}/api/v1/user`

const axiosInstance = axios.create({
  baseURL: `${apiBaseUrl}/auth`,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
})

const axiosAuthInstance = {
  get: async (url, params = {}, config = {}) => {
    const response = await axiosInstance.get(url, { params, ...config })
    return response
  },
  post: async (url, data, config) => {
    if (config) {
      return await axiosInstance.post(url, data, config)
    } else {
      return await axiosInstance.post(url, data)
    }
  },

  put: async (url, data, config) => {
    if (config) {
      return await axiosInstance.put(url, data, config)
    } else {
      return await axiosInstance.put(url, data)
    }
  },
}

export default axiosAuthInstance
